import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Solution from "./Solution";
import Benefits from "./Benefits";

export default function Service() {
    const itConsultingServices = [
        {
            id: 1,
            title: 'IT Roadmap Development',
            image: 'images/roadmap.png', // Replace with the appropriate image URL
            alt: 'IT roadmap development',
        },
        {
            id: 2,
            title: 'Technology Audit Consulting',
            image: 'images/audit.png', // Replace with the appropriate image URL
            alt: 'Technology audit consulting',
        },
        {
            id: 3,
            title: 'Project Management',
            image: 'images/prj.png', // Replace with the appropriate image URL
            alt: 'Project management',
        },
        {
            id: 4,
            title: 'Process Automation and Optimization',
            image: 'images/process.png', // Replace with the appropriate image URL
            alt: 'Process Automation and Optimization',
        },
    ];
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Services</h1>

                </div>

            </div>
            <Container className="it-overview text-center mt-5 mb-5">
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c' }}>
                    IT Strategy and Consulting
                </h3>
                <p
                    style={{
                        padding: '0 12%',
                        color: '#9b9aad',
                        fontWeight: '500',
                    }}
                >
                    Our IT Strategy and Consulting experts provide tailored guidance to organizations, offering technology solutions that align IT initiatives with business objectives. We focus on optimizing processes, fostering innovation, and enhancing efficiency to give businesses a competitive edge.
                </p>
                <Container className="py-3 services-main">
                    <Row className="g-4">
                        {itConsultingServices.map((service) => (
                            <Col sm={12} md={12} lg={3} key={service.id}>
                                <Card className="text-center shadow-sm h-100 services-its">
                                    <Card.Body>
                                        <div className="card-img">
                                            <img
                                                src={service.image}
                                                alt={service.alt}
                                                className="service-icon"
                                                style={{
                                                    width: '100px',
                                                    marginBottom: '30px',
                                                    marginTop: '35px',
                                                }}
                                            />
                                        </div>
                                        <Card.Title>{service.title}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Container>
            <Solution />
            <Benefits />
        </>
    )
}